import { Button } from '../../../styles/GlobalComponents';
import { Link } from 'react-router-dom';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { Icon, IconApproveNFTFail } from '../../../styles/Icons';
import { P2 } from '../../../styles/FontStyles';
import { DASHBOARD } from '../../../routes/routes';

export const Step8 = () => {
  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='20'>
              <IconApproveNFTFail />
            </Icon>
          </Flexed>
        </Flexed>

        <P2 bold center mb='20'>
          The withdrawal transaction has been declined.
        </P2>

        <Flexed column center>
          <Link to={DASHBOARD}>
            <Button w='200px' negative>
              Back to Dashboard
            </Button>
          </Link>
        </Flexed>
      </Box>
    </>
  );
};
